import React, {useCallback, useEffect, useState} from 'react';
import {Pressable, StyleSheet, Text, View, ScrollView} from 'react-native';
import {useDropzone} from 'react-dropzone';

const CampLicense = ({camp, setCamp}) => {
    const [files, setFiles] = useState(
        (camp && camp.campLicenses) ? camp.campLicenses : []
    );

    useEffect(() => {
        setCamp((prevState) => {
            const newState = {...prevState};

            if (files.length === 0) {
                delete newState['campLicenses'];
            } else {
                newState['campLicenses'] = files;
            }
            return newState;
        });
    }, [files]);

    const onDrop = useCallback((acceptedFiles) => {
        const newFiles = acceptedFiles.map(file => ({
            url: URL.createObjectURL(file),
            name: file.name,
            type: file.type,
        }));
        setFiles(prevFiles => [...prevFiles, ...newFiles]);
    }, []);

    const handleRemoveFile = (index) => {
        const newFiles = files.filter((_, i) => i !== index);
        setFiles(newFiles);
    };

    const {getRootProps, getInputProps} = useDropzone({
        onDrop,
        accept: {
            'application/pdf': ['.pdf'],
            'application/msword': ['.doc'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
            'text/plain': ['.txt']
        },
        multiple: true,
    });

    return (
        <ScrollView style={styles.container} contentContainerStyle={styles.contentContainer}>
            <View style={styles.field}>
                <Text style={styles.title}>Camp License</Text>
                <Text style={styles.subtitle}>Government issued permits/licenses are required to host a snap camp and
                    the documents are subject to verification.</Text>
            </View>

            <View {...getRootProps({className: 'dropzone'})} style={styles.dropzone}>
                <input {...getInputProps()} />
                <Text style={styles.dropzoneText}>Drag 'n' drop/click to upload the government issued permits/licenses.</Text>
            </View>

            {files.length > 0 && (
                <View style={styles.fileList}>
                    {files.map((file, index) => (
                        <View key={index} style={styles.fileContainer}>
                            <Text style={styles.fileName}>{file.name}</Text>
                            <Pressable
                                onPress={() => handleRemoveFile(index)}
                                style={styles.removeButton}
                            >
                                <Text style={styles.removeButtonText}>
                                    remove
                                </Text>
                            </Pressable>
                        </View>
                    ))}
                </View>
            )}
        </ScrollView>
    );
};

const styles = StyleSheet.create({
    fileContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 10,
        paddingHorizontal: 10,
        borderBottomWidth: 1,
        borderBottomColor: '#dddddd',
        paddingVertical: 5,
    },
    dropzone: {
        width: '100%',
        height: 150,
        borderWidth: 2,
        borderColor: '#cccccc',
        borderStyle: 'dashed',
        borderRadius: 10,
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 20,
        backgroundColor: '#f9f9f9',
    },
    dropzoneText: {
        color: '#cccccc',
        fontSize: 16,
    },
    removeButton: {
        backgroundColor: 'white',
        borderRadius: 15,
        padding: 8,
    },
    removeButtonText: {
        color: 'black',
        fontWeight: 'bold',
        fontSize: 15,
    },
    field: {
        flexDirection: 'column',
        marginBottom: 30,
    },
    container: {
        flex: 1,
    },
    contentContainer: {
        paddingHorizontal: 120,
        paddingTop: 40,
        paddingBottom: 40,
        minHeight: 500,
    },
    input: {
        height: 40,
        borderColor: 'gray',
        borderWidth: 1,
        marginBottom: 20,
        paddingHorizontal: 10,
    },
    title: {
        fontSize: 35,
        color: 'black',
        fontWeight: '600',
        marginBottom: 10,
    },
    subtitle: {
        fontSize: 15,
        color: 'grey',
    },
    uploadButtonText: {
        color: 'black',
        fontSize: 16,
        fontWeight: 'bold',
    },
    uploadButton: {
        backgroundColor: 'white',
        borderRadius: 8,
        padding: 10,
        width: '50%',
        alignItems: 'center',
        justifyContent: 'center',
    },
    uploadButtonContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 30,
    },
    fileList: {
        marginTop: 10,
        width: '100%',
    },
    fileName: {
        flex: 1,
        color: 'black',
        fontSize: 15,
    },
});

export default CampLicense;
